module.exports = __webpack_public_path__ + "img/TAT-SING-consulting-group-white.8d143bbf.png";